import { SET_FIRST_SPIN_MODAL_OPEN } from './actions/types'

const INITIAL_STATE = {
  spin: {
    firstModalOpen: false,
  },
}

const setFirstSpinModalOpen = (state, action) => {
  return {
    ...state,
    spin: {
      ...state.spin,
      firstModalOpen: action.payload.firstModalOpen,
    },
  }
}

function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_FIRST_SPIN_MODAL_OPEN:
      return setFirstSpinModalOpen(state, action)
    default:
      break
  }

  return state
}

export default reducer
